import { QuoteApprovalCardProps } from "./components/QuoteApprovalCard";

const APPROVAL_TYPES = {
  ALREADY_APPROVED: "Quote already approved",
  ALREADY_REJECTED: "Quote already rejected",
  ALREADY_PROCESSED: "Approval Request already processed.",
  NO_LONGER_VALID: "Quote no longer valid.",
  ANOTHER_APPROVED: "Another quote has been approved.",
  EXPIRED_QUOTE: "Quote has expired.",
  EXPIRED_REQUEST: "Quote Request has expired.",
  NO_LONGER_VALID_REQUEST: "Quote Request is no longer valid.",
  REDIRECT_TO_QUOTE: "Redirect to quotation approval page.",
  QUOTE_REQUEST_CANCELED: "Quote request canceled",
  TOKEN_EXPIRED: "Invalid or expired token.",
} as const;

const quickApprovalResponseDefaultOptions: (option: any) => QuoteApprovalCardProps = (option) => ({
  subtitle: `Shipment ID: ${option?.shipment_id || ""}`,
  providerLogo: option?.provider?.logo || "",
  providerName: option?.provider?.name || "",
  freightMode: option?.freight_mode || "",
  amount: option?.total_quoted_amount || "",
  currency: option?.total_quoted_amount_currency || "",
  shipmentId: option?.shipment_id || "",
});

const quickApprovalResponseOptions: Record<string, (option: any) => QuoteApprovalCardProps> = {
  [APPROVAL_TYPES.ALREADY_APPROVED]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote already approved",
    description: `${option?.actor || ""} has already approved this quote. No further action is required.`,
  }),
  [APPROVAL_TYPES.ALREADY_REJECTED]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote already rejected",
    description: `${option?.actor || ""} has already rejected this quote. No further action is required.`,
  }),
  [APPROVAL_TYPES.ALREADY_PROCESSED]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Approval Request already processed",
    description: "This quotation has already processed. No further action is required.",
  }),
  [APPROVAL_TYPES.NO_LONGER_VALID]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote no longer valid",
    description: `${option.actor || ""} canceled the quote. Please book another quote.`,
  }),
  [APPROVAL_TYPES.ANOTHER_APPROVED]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Another quote has been approved",
    description: "Another quote has been approved for this shipment. No further action is required.",
  }),
  [APPROVAL_TYPES.EXPIRED_QUOTE]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote no longer valid",
    description: "This quote has expired. Please request for an extension.",
  }),
  [APPROVAL_TYPES.EXPIRED_REQUEST]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote Request has expired.",
    description: "The quote request has expired. Please request for an extension.",
  }),
  [APPROVAL_TYPES.NO_LONGER_VALID_REQUEST]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote Request is no longer valid.",
    description: "The quote request is no longer valid. Please request for a new quote.",
  }),
  [APPROVAL_TYPES.QUOTE_REQUEST_CANCELED]: (option) => ({
    ...quickApprovalResponseDefaultOptions(option),
    showIcon: false,
    title: "Quote Request canceled.",
    description: `${option?.actor || ""} canceled the quote request. No further action is required.`,
  }),
};

export { quickApprovalResponseDefaultOptions, quickApprovalResponseOptions, APPROVAL_TYPES };
